import {
    AfterContentInit,
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { AuthService } from '../../../global-services/auth.service';
import { User } from '../../../user-account/user.model';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { DBC_SCREENS } from 'app/app.constants';

@Component({
    selector: 'app-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrl: './top-nav.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopNavComponent implements OnInit, AfterContentInit, OnDestroy {
    user: User;
    openAccountsDrawer: boolean;
    isLoggedIn$: Observable<boolean>;
    
    // Subjects
    ngUnsubscribe: Subject<any> = new Subject();
    isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    isLoading$: Observable<boolean> = this.isLoadingSubject.pipe();
    backCtaRouteSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

    
    private readonly redirectionRouteSub!: Subscription;
    redirectionRoute$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    protected readonly navigator = navigator;
    protected readonly FRAGMENT_TO_ROUTE_MAP = [
        {FRAGMENT_NAME: DBC_SCREENS.LEAD_LIST, REDIRECT_TO: '/cards'},
        {FRAGMENT_NAME: DBC_SCREENS.CAPTURE, REDIRECT_TO: '/cards'}
    ]


    constructor(private readonly authService: AuthService,private readonly activatedRoute: ActivatedRoute,private readonly router: Router) {
        this.isLoggedIn$ = this.authService.isLoggedIn$;
        this.authService.user$.pipe().subscribe((res) => {
            this.user = res;
        });
        this.isLoadingSubject.next(true);
        this.user = this.authService.getUser();

        // Maps the URL fragment to a redirection route based on ROUTE_REDIRECTIONS.
        // Updates backCtaRouteSubject with the matching route or an empty string if no match is found
        this.redirectionRouteSub! = this.activatedRoute.fragment.pipe(
            map((fragment: string) => {
                let routeValue = '';
                for (const passedRouteFragment of this.FRAGMENT_TO_ROUTE_MAP) {
                    if (fragment === passedRouteFragment.FRAGMENT_NAME) {
                        routeValue = passedRouteFragment.REDIRECT_TO;
                        break;
                    }
                }
                return routeValue;
            })
        ).subscribe(fragment => {
            this.redirectionRoute$.next(fragment);
        });
    }

    ngOnInit() {}

    ngAfterContentInit() {
        this.authService.isAuthenticated$
            .pipe(
                filter((val) => val !== null),
                distinctUntilChanged()
            )
            .subscribe((val) => {
                this.isLoadingSubject.next(false);
            });
    }

    handleOutsideClickOfAccountDrawer(value) {
        this.openAccountsDrawer = value;
    }

    handleAccountsDrawer() {
        this.openAccountsDrawer = true;
    }

    redirectToLogin() {
        this.authService.auth0Login('/cards');
    }

    handleBackButtonRedirection() {
        const backLink = this.redirectionRoute$.getValue() ?? '';
        this.router.navigate(['/cards'], {
            fragment: backLink,
            skipLocationChange: false,
        });
    }

    ngOnDestroy() {
        this.redirectionRouteSub?.unsubscribe();
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
}
